import { Component, EventEmitter, Inject, OnInit, Output } from '@angular/core'
import {
  FormBuilder,
  FormGroup,
  ReactiveFormsModule,
  ValidatorFn,
  Validators,
} from '@angular/forms'
import { MatButton } from '@angular/material/button'
import { MatProgressSpinner } from '@angular/material/progress-spinner'
import { SnackbarCustomService } from '../../../../shared/components/snackbar/snackbar-custom.service'
import {
  ErrorRequestModel,
  ResponseRequestModel,
} from '../../../../core/models/response.model'
import { MatFormFieldModule } from '@angular/material/form-field'
import { MatCardModule } from '@angular/material/card'
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog'
import { MatExpansionModule } from '@angular/material/expansion'
import { MatInput } from '@angular/material/input'
import { MatDividerModule } from '@angular/material/divider'
import { NgxMaskDirective } from 'ngx-mask'
import { AddressClientEditComponent } from '../../../address/address-client-edit/address-client-edit.component'
import { ContactClientEditComponent } from '../../../contact/contact-client-edit/contact-client-edit.component'
import { TaxDocumentClientEditComponent } from '../../../tax-document/tax-document-client-edit/tax-document-client-edit.component'
import { PaymentMethodsClientEditComponent } from '../../../payment/payment-client-edit/payment-methods-client-edit.component'
import { BankDetailsClientEditComponent } from '../../../bank/bank-details-client-edit/bank-details-client-edit.component'
import { ConsultantClientEditComponent } from '../../../person/consultant-client-edit/consultant-client-edit.component'
import { AssociateClientEditComponent } from '../associate-client/associate-client-edit/associate-client-edit.component'
import { TariffClientEditComponent } from '../../../tariff/tariff-client-edit/tariff-client-edit.component'
import { CurrencyInputDirective } from '../../../../shared/directives/currencyInput'
import { DecimalInputDirective } from '../../../../shared/directives/decimalInput'
import {
  MatSlideToggle,
  MatSlideToggleChange,
} from '@angular/material/slide-toggle'
import { CommissionDividerService } from '../../../../core/services/price-quote/commission-divider/commission-divider.service'
import { convertCurrency } from '../../../../shared/utils/utils'
import { SubClientService } from '../../../../core/services/customer/sub-client/sub-client.service'
import { ResponsibleClientEditComponent } from '../../../person/responsible-client-edit/responsible-client-edit.component'
import { AssociateSubClientEditComponent } from '../../client-edit/associate-sub-client-edit/associate-sub-client-edit.component'
import { AssociateConsultantOperateEditComponent } from '../../../employee/associate-consultant-operate-edit/associate-consultant-operate-edit.component'
import { MatOption } from '@angular/material/core'
import { MatSelect } from '@angular/material/select'
import { cnpjValidator } from '../../../../shared/utils/cnpj_validator'
import { cpfValidator } from '../../../../shared/utils/cpf_validator'
import { NgClass } from '@angular/common'

@Component({
  selector: 'sub-client-edit',
  imports: [
    ReactiveFormsModule,
    MatButton,
    MatProgressSpinner,
    MatExpansionModule,
    MatFormFieldModule,
    MatCardModule,
    MatInput,
    MatDividerModule,
    NgxMaskDirective,
    AddressClientEditComponent,
    ContactClientEditComponent,
    TaxDocumentClientEditComponent,
    PaymentMethodsClientEditComponent,
    BankDetailsClientEditComponent,
    ConsultantClientEditComponent,
    AssociateClientEditComponent,
    TariffClientEditComponent,
    CurrencyInputDirective,
    DecimalInputDirective,
    MatSlideToggle,
    ResponsibleClientEditComponent,
    AssociateSubClientEditComponent,
    AssociateConsultantOperateEditComponent,
    MatOption,
    MatSelect,
    NgClass,
  ],
  templateUrl: './sub-client-edit.component.html',
  styleUrl: './sub-client-edit.component.scss',
  providers: [SubClientService, CommissionDividerService],
  standalone: true,
})
export class SubClientEditComponent implements OnInit {
  constructor(
    private formBuilder: FormBuilder,
    private subClientService: SubClientService,
    private commissionDividerService: CommissionDividerService,
    private snackbar: SnackbarCustomService,
    private dialogRef: MatDialogRef<SubClientEditComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
    this.item = data.item
    this.individualPerson = data.item.razaoSocial.trim() == 'PF' ? true : false
    this.commissionDividerClient = {
      idCLient: this.item.isCLient,
      taxa: this.item.taxa ?? 0,
      divisor: this.item.divisor ?? 0,
      comissao: this.item.comissao ?? 0,
    }
    if (data.type == 'legal-entity-client') {
      this.listTypeClient.push({ id: 'legal', description: 'Pessoa Jurídica' })
    } else if (data.type == 'individual-client') {
      this.listTypeClient.push({
        id: 'individual',
        description: 'Pessoa Fisica',
      })
    }
  }

  @Output() response = new EventEmitter()

  individualPerson: boolean = false

  formLegalEntity: FormGroup = new FormGroup({})
  formIndividual: FormGroup = new FormGroup({})
  formFinancial: FormGroup = new FormGroup({})
  listTypeClient: any = [
    { id: 'legal', description: 'Pessoa Jurídica' },
    // { id: 'individual', description: 'Pessoa Fisica' },
  ]

  typeClient: 'legal' | 'individual' = 'legal'

  item: any
  loading: boolean = false
  loadingScreen: boolean = true

  commissionDivider: any = {
    taxa: 0.0,
    divisor: 0.0,
    comissao: 0.0,
  }

  commissionDividerClient: any = {
    taxa: 0.0,
    divisor: 0.0,
    comissao: 0.0,
  }

  panelAdress: boolean = false
  panelContact: boolean = false
  panelResponsable: boolean = false
  panelFinancial: boolean = false
  panelBankDetails: boolean = false
  panelConsultant: boolean = false
  panelConsultantOp: boolean = false
  panelTariff: boolean = false
  panelSubClient: boolean = false

  ngOnInit(): void {
    this.createForm()
    this.getCommissionDivider()
  }

  close() {
    this.dialogRef.close()
  }

  private getDocumentValidator(): ValidatorFn {
    return this.individualPerson ? cpfValidator() : cnpjValidator()
  }

  createForm(): void {
    this.formLegalEntity = this.formBuilder.group({
      name: [this.item.nomeFantasia, [Validators.required]],
      cnpj: [
        this.item.cnpj,
        [Validators.required, this.getDocumentValidator()],
      ],
      corporate_name: [this.item.razaoSocial, [Validators.required]],
      reg_state: [this.item.inscricaoEstadual],
      reg_municipal: [this.item.inscricaoMunicipal],
    })
    this.formIndividual = this.formBuilder.group({
      name: ['', [Validators.required]],
      cpf: ['', [Validators.required]],
    })
    this.formFinancial = this.formBuilder.group({
      tgmob: [true],
      tax: [''],
      commission: [''],
      divider: [''],
    })
    this.checkDivider()
    this.loadingScreen = false
  }

  checkDivider() {
    if (this.item.divisorId) {
      this.formFinancial.get('tgmob')!.setValue(false)
      this.fillFormFinancial(true)
    } else {
      this.fillFormFinancial()
    }
  }

  checkInvalidForm() {
    if (
      (this.typeClient == 'legal' && this.formLegalEntity.invalid) ||
      (this.typeClient == 'individual' && this.formIndividual.invalid) ||
      // this.formFinancial.invalid ||
      this.loading
    ) {
      return true
    } else {
      return false
    }
  }

  editLegalModel() {
    return {
      id: this.item.id,
      pessoaId: this.item.pessoaId,
      razaoSocial: this.individualPerson
        ? 'PF'
        : (this.formLegalEntity.get('corporate_name')?.value ?? ''),
      inscEstadual: this.individualPerson
        ? ''
        : (this.formLegalEntity.get('reg_municipal')?.value ?? ''),
      inscMunicipal: this.individualPerson
        ? ''
        : (this.formLegalEntity.get('reg_state')?.value ?? ''),
      cnpj: this.formLegalEntity.get('cnpj')?.value ?? '',
      nome: this.formLegalEntity.get('name')?.value ?? '',
      // razaoSocial: this.formLegalEntity.get('corporate_name')?.value ?? '',
      // inscEstadual: this.formLegalEntity.get('reg_state')?.value ?? '',
      // inscMunicipal: this.formLegalEntity.get('reg_municipal')?.value ?? '',
      isCliente: this.formFinancial.get('tgmob')?.value ? 'N' : 'S',
      divisor: convertCurrency(this.formFinancial.get('divider')!.value),
      comissao: convertCurrency(this.formFinancial.get('commission')!.value),
      taxa: convertCurrency(this.formFinancial.get('tax')!.value),
      ativo: 'S',
    }
  }

  editIndividualModel() {
    return {
      nome: this.formLegalEntity.get('name')?.value ?? '',
      cpf: this.formLegalEntity.get('cpf')?.value ?? '',
    }
  }

  onChangeSelect(event: MatSlideToggleChange) {
    if (event.checked) {
      this.fillFormFinancial()
    } else {
      this.fillFormFinancial(true)
    }
  }

  fillFormFinancial(clear: boolean = false) {
    if (!clear) {
      this.formFinancial
        .get('divider')!
        .setValue(convertCurrency(this.commissionDivider.divisor))
      this.formFinancial
        .get('tax')!
        .setValue(convertCurrency(this.commissionDivider.taxa))
      this.formFinancial
        .get('commission')!
        .setValue(convertCurrency(this.commissionDivider.comissao))
      this.formFinancial.get('divider')!.disable()
      this.formFinancial.get('tax')!.disable()
      this.formFinancial.get('commission')!.disable()
    } else {
      this.formFinancial
        .get('divider')!
        .setValue(convertCurrency(this.commissionDividerClient.divisor))
      this.formFinancial
        .get('tax')!
        .setValue(convertCurrency(this.commissionDividerClient.taxa))
      this.formFinancial
        .get('commission')!
        .setValue(convertCurrency(this.commissionDividerClient.comissao))
      this.formFinancial.get('divider')!.enable()
      this.formFinancial.get('tax')!.enable()
      this.formFinancial.get('commission')!.enable()
    }
  }

  getCommissionDivider() {
    this.commissionDividerService.getCommissionDividerDefault().subscribe({
      next: (response: ResponseRequestModel) => {
        this.commissionDivider = {
          taxa:
            response && response.data && response.data.taxa
              ? response.data.taxa
              : 0,
          divisor:
            response && response.data && response.data.divisor
              ? response.data.divisor
              : 1,
          comissao:
            response && response.data && response.data.comissao
              ? response.data.comissao
              : 0,
        }
        // this.commissionDivider = {
        //   taxa: response.data.taxa,
        //   divisor: response.data.divisor,
        //   comissao: response.data.comissao,
        // }
        this.checkDivider()
      },
      error: (err: ErrorRequestModel) => {
        console.error('err', err)
      },
      complete: () => {},
    })
  }

  editClient() {
    this.loading = true
    if (this.typeClient == 'legal') {
      this.editClientLegal()
    } else if (this.typeClient == 'individual') {
      this.editClientIndividual()
    } else {
      this.snackbar.error('Selecione um tipo de Cliente')
    }
  }

  editClientLegal() {
    this.subClientService.editSubClient(this.editLegalModel()).subscribe({
      next: (response: ResponseRequestModel) => {
        this.snackbar.success(response.message)
        this.response.emit(true)
        this.close()
      },
      error: (err: ErrorRequestModel) => {
        this.loading = false
        this.snackbar.errorRequest(err)
      },
      complete: () => {
        this.loading = false
        this.formLegalEntity.reset()
        this.formFinancial.reset()
      },
    })
  }

  editClientIndividual() {
    // this.individualClientService
    //   .createIndividualClient(this.editIndividualModel())
    //   .subscribe({
    //     next: (response: ResponseRequestModel) => {
    //       this.snackbar.success(response.message)
    //       this.response.emit(true)
    //       this.close()
    //     },
    //     error: (err: ResponseRequestModel) => {
    //       this.loading = false
    //       this.snackbar.error(err.error)
    //     },
    //     complete: () => {
    //       this.loading = false
    //       this.formIndividual.reset()
    //       this.formFinancial.reset()
    //     },
    //   })
  }
}
